import { useState } from 'react'
import StyledToggle from 'common/components/StyledToggle'

const StatusRenderer = () => {
  const [toggleStatus, setToggleStatus] = useState<boolean>(false)

  return (
    <StyledToggle
      checked={toggleStatus}
      onClick={() => {
        setToggleStatus(!toggleStatus)
      }}
    />
  )
}

export default StatusRenderer
